import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-remove",
  "use": "app-icon-remove-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-remove\"><g fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#FF4C4C\" fill=\"#FFF\" cx=\"8\" cy=\"8\" r=\"7.5\" /><path fill=\"#FF5757\" d=\"M4 7h8v2H4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol